export { default as AssessmentsTable } from "./AssessmentsTable";
